import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useLanguage() {
  const { locale } = useI18n()
  
  const availableLanguages = [
    { code: 'en', name: 'English', flag: '/images/flags/en.png' }, // English first (default)
    { code: 'ro', name: 'Română', flag: '/images/flags/ro.png' },
    { code: 'fr', name: 'Français', flag: '/images/flags/fr.png' },
    { code: 'it', name: 'Italiano', flag: '/images/flags/it.png' },
    { code: 'de', name: 'Deutsch', flag: '/images/flags/de.png' },
    { code: 'es', name: 'Español', flag: '/images/flags/es.png' }
  ]

  const currentLanguage = computed(() => {
    return availableLanguages.find(lang => lang.code === locale.value) || availableLanguages[0]
  })

  const setLanguage = (langCode: string) => {
    locale.value = langCode
    // Store in localStorage for persistence
    localStorage.setItem('preferred-language', langCode)
  }

  const initializeLanguage = () => {
    const savedLanguage = localStorage.getItem('preferred-language')
    if (savedLanguage && availableLanguages.some(lang => lang.code === savedLanguage)) {
      locale.value = savedLanguage
    }
  }

  return {
    availableLanguages,
    currentLanguage,
    setLanguage,
    initializeLanguage
  }
}
